import { useLocalObservable } from 'mobx-react-lite';

import { Call } from '@gem/call/CallStore/Call';

import { ICallSpeakerListBlockProps } from './CallSpeakerListBlock.types';

interface ICallSpeakerListBlockPresenter {
  ongoingCall: Call;
  activeSpeakersIds: string[];
}

export const useCallSpeakerListBlockPresenter = (
  props: ICallSpeakerListBlockProps
): ICallSpeakerListBlockPresenter => {
  const presenter = useLocalObservable<ICallSpeakerListBlockPresenter>(() => ({
    get ongoingCall(): Call {
      return props.call;
    },

    get activeSpeakersIds(): string[] {
      return presenter.ongoingCall.members.memberList
        .filter((item) => {
          return item.isAdmin;
        })
        .map((item) => item.userId);
    },
  }));

  return presenter;
};
